import { isFeatureEnabled } from 'owa-feature-flags';

/**
 * Helper function to determine if guided formulation should be enabled. As part
 * of the GF experimentation plan, there are 6 server-side treatments (thus 6
 * flights) and GF should be enabled for each treatment.
 */
export function isGfEnabled(): boolean {
    return (
        isFeatureEnabled('sea-gf1') ||
        isFeatureEnabled('sea-gf2') ||
        isFeatureEnabled('sea-gf3') ||
        isFeatureEnabled('sea-gf4') ||
        isFeatureEnabled('sea-gf5') ||
        isFeatureEnabled('sea-gf6') ||
        // Legacy flight (for internal rings)
        isFeatureEnabled('sea-gf')
    );
}

/**
 * Helper function to determine if pill display text should be sent as part of QF.
 * As part of the GF experimentation plan, there are 6 server-side treatments (thus 6
 * flights) and this behavior should be enabled for treatments 2, 4, and 6.
 */
export function shouldSendPillDisplayText(): boolean {
    return (
        isFeatureEnabled('sea-gf2') ||
        isFeatureEnabled('sea-gf4') ||
        isFeatureEnabled('sea-gf6') ||
        isFeatureEnabled('sea-gfct1') ||
        // Legacy flight (for internal rings)
        isFeatureEnabled('sea-sendPillDisplayText')
    );
}
